import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// State

export interface ProgressBarState {
    step: number;
}

export const initialState: ProgressBarState = {
    step: 1,
};

// Slice

export const progressSlice = createSlice({
    name: 'progress',
    initialState,
    reducers: {
        setProgressStep: (state, action: PayloadAction<{ step: number }>) => {
            if (action.payload && action.payload.step) {
                state.step = action.payload.step; // Immer handles immutability
            }
        },
    },
});

// Actions

export const { setProgressStep } = progressSlice.actions;

// Reducer

export const progressReducer = progressSlice.reducer;